"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _extends = require("@babel/runtime/helpers/extends");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@pattern-library/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = _extends({}, null), a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint jsx-a11y/no-noninteractive-tabindex: 0 */

class FocusTrap extends _react.Component {
  constructor(props) {
    super(props);
    this.handleTopFocus = event => {
      const {
        onTopFocus
      } = this.props;
      _utils.FocusService.focusElement(this.lastFocusableElement);
      onTopFocus(event);
    };
    this.handleBottomFocus = event => {
      const {
        onBottomFocus
      } = this.props;
      _utils.FocusService.focusElement(this.firstFocusableElement);
      onBottomFocus(event);
    };
    this.state = {
      focusableElements: []
    };
  }
  componentDidMount() {
    const focusableElements = this.findFocusableElements();
    this.setState({
      focusableElements
    });
  }
  findFocusableElements() {
    const elements = _utils.FocusService.getFocusableElementsIn(this.container);
    // remove the first and last items in the array, which are the focus traps
    elements.shift();
    elements.pop();
    return elements;
  }
  get firstFocusableElement() {
    const {
      focusableElements
    } = this.state;
    return focusableElements[0];
  }
  get lastFocusableElement() {
    const {
      focusableElements
    } = this.state;
    return focusableElements[focusableElements.length - 1];
  }
  render() {
    const {
      children,
      isBottomActive,
      isTopActive
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "asc-focus-trap",
      ref: node => {
        this.container = node;
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "asc-acc-hidden",
      tabIndex: isTopActive ? '0' : '-1',
      onFocus: this.handleTopFocus
    }), children, /*#__PURE__*/_react.default.createElement("span", {
      className: "asc-acc-hidden",
      tabIndex: isBottomActive ? '0' : '-1',
      onFocus: this.handleBottomFocus
    }));
  }
}
FocusTrap.propTypes = {
  /**
   * Toggle the bottom focus trap on and off
   */
  isBottomActive: _propTypes.default.bool,
  /**
   * Toggle the top focus trap on and off
   */
  isTopActive: _propTypes.default.bool,
  /**
   * Content to display within the focus trap
   */
  children: _propTypes.default.node,
  /**
   * Callback function when the bottom focus trap is hit
   */
  onBottomFocus: _propTypes.default.func,
  /**
   * Callback function when the top focus trap is hit
   */
  onTopFocus: _propTypes.default.func
};
FocusTrap.defaultProps = {
  isBottomActive: true,
  isTopActive: true,
  onBottomFocus: () => {},
  onTopFocus: () => {}
};
var _default = exports.default = FocusTrap;